import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { onReadyWidgetOfType } from '../utils/helper';

onReadyWidgetOfType("HomepageCarouselBanner", (widget, data) => {
    // console.log({ widget, data })
    const swiperElement = widget.querySelector(".homepage-carousel-banner-swipper")
    const pagination = widget.querySelector(".swiper-pagination")

    /**
     * @type {import('swiper').Swiper}
     */
    var swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        // spaceBetween: 28,
        pagination: {
            el: pagination,
            clickable: true,
        },
        loop: data.loop,
        autoplay: data.autoplay ? { delay: 5000 } : false,
        resizeEvent: 'auto'
        // navigation: {
        //     nextEl: nextEl,
        //     prevEl: prevEl,
        // },
    })

    swiper.on("slideChange", () => {
        console.log("HomepageCarouselBanner Slide Change")
    })
})
